import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  typeYourCitation: {
    id: 'Placeholder.TypeYourCitation',
    defaultMessage: 'Type your citation here.'
  },
  writeABriefDescriptionOfFile: {
    id: 'Placeholder.writeABriefDescriptionOfFile',
    defaultMessage: 'Write a brief description of this file (optional)'
  },
  searchForTheQuest: {
    id: 'Placeholder.SearchForTheQuest',
    defaultMessage: 'Search for the quest by name here'
  },
  http: {
    id: 'Placeholder.Http',
    defaultMessage: 'http://'
  },
  selectTags: {
    id: 'Placeholder.SelectTags',
    defaultMessage: 'Select tags'
  },
  giveMentorsBackgroundInfo: {
    id: 'Placeholder.GiveMentorsBackgroundInfo',
    defaultMessage:
      'Give mentors some background information or tips for this quest'
  },
  selectAuthors: {
    id: 'Placeholder.SelectAuthors',
    defaultMessage: 'Select authors'
  },
  typeYourComment: {
    id: 'Placeholder.TypeYourComment',
    defaultMessage: 'Type your comment here.'
  },
  artifactDescription: {
    id: 'Placeholder.ArtifactDescription',
    defaultMessage:
      'Describe what learners will do and why and which skills and knowledge should be demonstrated.'
  },
  enterTitle: {
    id: 'Placeholder.EnterTitle',
    defaultMessage: 'Enter all or part of a quest title'
  },
  selectSubject: {
    id: 'Placeholder.SelectSubject',
    defaultMessage: 'Select subjects'
  },
  selectColleagues: {
    id: 'Placeholder.SelectColleagues',
    defaultMessage: 'Select colleagues'
  },
  selectAPeer: {
    id: 'Placeholder.SelectAPeer',
    defaultMessage: 'Select a peer...'
  },
  writeThemAMessage: {
    id: 'Placeholder.WriteThemAMessage',
    defaultMessage: 'Write them a message...'
  },
  selectGrades: {
    id: 'Placeholder.SelectGrades',
    defaultMessage: 'Select grades'
  }
})



// WEBPACK FOOTER //
// ./src/utils/messages/placeholder.js